/**
 * The granted price cards the plan page's 24-month example can use (TMMAPI-0131): every granted
 * card, the adopted one first, then the rest by name. The pick lives in the URL (`?card=<id>`, a
 * granted card's id); an id that isn't a choice falls back to the first choice (the adopted card).
 */
import type { GrantedCard } from '@/api/rateCards';
import { intlLocale } from '@/i18n/constants';

export function exampleCardChoices(cards: GrantedCard[], locale: string): GrantedCard[] {
  return [...cards].sort(
    (a, b) =>
      Number(b.adopted) - Number(a.adopted) || a.name.localeCompare(b.name, intlLocale(locale)),
  );
}

/** The `?card=` value's card when it is a choice, else the default (the first choice), or `null`. */
export function pickExampleCard(choices: GrantedCard[], param: string | null): GrantedCard | null {
  const id = param !== null && /^\d+$/.test(param) ? Number(param) : null;
  return choices.find((card) => card.id === id) ?? choices[0] ?? null;
}
